<fgb-page-header
  [pageTitle]="'payment.page.title'"
  [backButtonLink]="'/payment'"
></fgb-page-header>

<div class="container d-flex align-items-center">
  <div class="card mx-auto">
    <div class="card-body text-center py-3">
      <div class="card-heading">
        <i class="material-icons me-2 text-danger">add_card</i>
        <h5 class="text-danger">
          {{ "ecash.failure.page.title" | translate }}
        </h5>
      </div>
      <div class="mt-4 sub-heading-modal">
        <div class="text-center">
          {{ "ecash.failure.page.card.message" | translate }}
        </div>
      </div>
      <div class="btn-container mt-2 d-block">
        <button
          [routerLink]="['/payment']"
          type="button"
          class="btn btn-danger text-white mx-2 mt-4 fw-bold"
        >
          {{ "ecash.failure.page.close.button" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
